import calendar from './projects/calendar.js';
import design from './projects/design.js';
import dashboard from './projects/dashboard.js';

export const projects = [calendar, design, dashboard];